import { render, staticRenderFns } from "./layoutExample.vue?vue&type=template&id=2d0d7472&scoped=true"
import script from "./layoutExample.vue?vue&type=script&lang=js"
export * from "./layoutExample.vue?vue&type=script&lang=js"
import style0 from "./layoutExample.vue?vue&type=style&index=0&id=2d0d7472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0d7472",
  null
  
)

export default component.exports